export function Logo({ light = true }: { light?: boolean }) {
  void light;
  return <img src="/assets/Logo.png" alt="LUXFRAME" className="logo-img" />;
}
